/**
 * Love Store Paris — Pop-ups globaux (bienvenue -10%, VIP, avis Google)
 */
(function () {
  'use strict';

  var STORAGE = {
    welcome: 'lspPopupWelcomeClosed',
    vip: 'lspPopupVipClosed',
    reviews: 'lspPopupReviewsClosed'
  };

  function nowMs() {
    return Date.now();
  }

  function isExpired(key) {
    var raw = localStorage.getItem(key);
    if (!raw) return true;
    var expiry = parseInt(raw, 10);
    return isNaN(expiry) || expiry < nowMs();
  }

  function setExpiry(key, hours) {
    localStorage.setItem(key, String(nowMs() + hours * 60 * 60 * 1000));
  }

  function setPermanent(key) {
    localStorage.setItem(key, String(nowMs() + 365 * 24 * 60 * 60 * 1000));
  }

  function slugifyTag(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function parseCountdownEnd(value) {
    if (!value) return NaN;
    return Date.parse(String(value).trim().replace(' ', 'T'));
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-lsp-popup-countdown]');
    if (!countdown || countdown.dataset.lspCountdownInit === 'true') return;
    countdown.dataset.lspCountdownInit = 'true';

    function tick() {
      var end = parseCountdownEnd(countdown.getAttribute('data-countdown-end'));
      if (isNaN(end)) return;
      var liveEnd = end;
      var total = Math.max(0, Math.floor((liveEnd - Date.now()) / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;

      countdown.querySelectorAll('[data-unit]').forEach(function (el) {
        var key = el.getAttribute('data-unit');
        var val = 0;
        if (key === 'days') val = days;
        if (key === 'hours') val = hours;
        if (key === 'minutes') val = mins;
        if (key === 'seconds') val = secs;
        el.textContent = String(val).padStart(2, '0');
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lsp-popup-open');
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.lsp-popup-overlay.is-open')) {
      document.documentElement.classList.remove('lsp-popup-open');
    }
  }

  function isWelcomeSuccessContent(text) {
    if (!text) return false;
    return /customer_posted=true|newsletter-form__message--success|form\.posted_successfully|already|déjà|subscribed|inscrit|thank you|merci/i.test(
      text
    );
  }

  function prepareWelcomeTags(form, firstName) {
    var tagsInput = form.querySelector('[name="contact[tags]"]');
    var baseTags = (tagsInput && tagsInput.value) || 'newsletter, popup-welcome';
    var slug = slugifyTag(firstName);
    var nextTags = baseTags;
    if (slug) nextTags += ', prenom-' + slug;
    if (tagsInput) tagsInput.value = nextTags;
  }

  function showWelcomeSuccess(form, success, errorEl) {
    if (form) form.hidden = true;
    if (success) success.classList.add('is-visible');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    setPermanent(STORAGE.welcome);
  }

  function clearWelcomeReturnParams() {
    if (!window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (!url.searchParams.has('customer_posted')) return;
    url.searchParams.delete('customer_posted');
    if (url.hash && url.hash.indexOf('LspPopupWelcome') !== -1) url.hash = '';
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function bindWelcomeFormSubmit(form) {
    if (!form || form.dataset.lspWelcomeSubmitInit === 'true') return;
    form.dataset.lspWelcomeSubmitInit = 'true';

    form.addEventListener('submit', function (e) {
      var firstNameInput = form.querySelector('[data-lsp-popup-first-name]');
      var emailInput = form.querySelector('[name="contact[email]"]');
      var firstName = firstNameInput && firstNameInput.value ? firstNameInput.value.trim() : '';
      var email = emailInput && emailInput.value ? emailInput.value.trim() : '';

      if (!firstName || !email) {
        e.preventDefault();
        return;
      }

      prepareWelcomeTags(form, firstName);
    });
  }

  function welcomePostedOnLoad(overlay, form, success) {
    if (success && success.classList.contains('is-visible')) {
      openOverlay(overlay);
      if (form) form.hidden = true;
      setPermanent(STORAGE.welcome);
      return true;
    }
    return false;
  }

  function maybeShowWelcomeReturnSuccess(overlay) {
    var params = new URLSearchParams(window.location.search);
    var hash = window.location.hash || '';
    if (!params.has('customer_posted') || hash.indexOf('LspPopupWelcome') === -1) return false;

    var form = overlay.querySelector('form.lsp-popup-welcome-form');
    var success = overlay.querySelector('[data-lsp-popup-welcome-success]');
    var errorEl = overlay.querySelector('[data-lsp-popup-welcome-error]');

    openOverlay(overlay);
    showWelcomeSuccess(form, success, errorEl);
    clearWelcomeReturnParams();
    return true;
  }

  function initWelcome(root, config, onClose) {
    var overlay = root.querySelector('[data-lsp-popup-welcome]');
    if (!overlay || config.enabled !== 'true') {
      return false;
    }

    var form = overlay.querySelector('form.lsp-popup-welcome-form');
    var success = overlay.querySelector('[data-lsp-popup-welcome-success]');
    var errorEl = overlay.querySelector('[data-lsp-popup-welcome-error]');
    var dismissHours = parseInt(config.dismissHours, 10) || 168;
    var welcomeDelay = (parseInt(config.delay, 10) || 8) * 1000;

    if (welcomePostedOnLoad(overlay, form, success)) {
      clearWelcomeReturnParams();
      bindWelcomeClose(overlay, dismissHours, onClose);
      return false;
    }

    if (maybeShowWelcomeReturnSuccess(overlay)) {
      bindWelcomeClose(overlay, dismissHours, onClose);
      return false;
    }

    var canShow = isExpired(STORAGE.welcome);

    bindWelcomeClose(overlay, dismissHours, onClose);
    bindWelcomeFormSubmit(form);

    if (form && form.querySelector('.lsp-popup-error:not([hidden])')) {
      openOverlay(overlay);
      return false;
    }

    if (!canShow) {
      return false;
    }

    window.setTimeout(function () {
      openOverlay(overlay);
    }, welcomeDelay);

    return true;
  }

  function bindWelcomeClose(overlay, dismissHours, onClose) {
    if (!overlay || overlay.dataset.lspWelcomeCloseInit === 'true') return;
    overlay.dataset.lspWelcomeCloseInit = 'true';

    function closeWelcome() {
      closeOverlay(overlay);
      setExpiry(STORAGE.welcome, dismissHours);
      if (onClose) onClose();
    }

    overlay.querySelectorAll('[data-lsp-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', closeWelcome);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeWelcome();
    });
  }

  function scheduleVip(root, config, delayMs) {
    var overlay = root.querySelector('[data-lsp-popup-vip]');
    if (!overlay || config.enabled !== 'true') return;
    if (!isExpired(STORAGE.vip)) return;

    initCountdown(overlay);
    var dismissHours = parseInt(config.dismissHours, 10) || 4;

    function closeVip() {
      closeOverlay(overlay);
      setExpiry(STORAGE.vip, dismissHours);
    }

    overlay.querySelectorAll('[data-lsp-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', closeVip);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeVip();
    });

    window.setTimeout(function () {
      if (!isExpired(STORAGE.vip)) return;
      if (document.querySelector('.lsp-popup-overlay.is-open')) return;
      openOverlay(overlay);
    }, delayMs || 0);
  }

  function initReviews(root, config) {
    var toast = root.querySelector('[data-lsp-popup-reviews]');
    if (!toast || config.enabled !== 'true') return;
    if (localStorage.getItem(STORAGE.reviews) === 'true') return;

    var messages = [];
    try {
      messages = JSON.parse(toast.getAttribute('data-messages') || '[]');
    } catch (e) {
      messages = [];
    }
    if (!messages.length) return;

    var textEl = toast.querySelector('[data-lsp-popup-reviews-text]');
    var index = 0;
    var intervalId;

    function showMessage() {
      if (textEl) textEl.textContent = messages[index];
      toast.classList.add('is-visible');
      index = (index + 1) % messages.length;
    }

    function closeReviews() {
      toast.classList.remove('is-visible');
      if (intervalId) clearInterval(intervalId);
      localStorage.setItem(STORAGE.reviews, 'true');
    }

    var closeBtn = toast.querySelector('[data-lsp-popup-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeReviews);

    window.setTimeout(function () {
      showMessage();
      intervalId = window.setInterval(showMessage, parseInt(config.interval, 10) * 1000 || 6000);
    }, parseInt(config.delay, 10) * 1000 || 4000);
  }

  function initPopups(root) {
    if (!root || root.dataset.lspPopupsInit === 'true') return;
    root.dataset.lspPopupsInit = 'true';

    var vipConfig = {
      enabled: root.getAttribute('data-vip-enabled'),
      delay: root.getAttribute('data-vip-delay'),
      dismissHours: root.getAttribute('data-vip-dismiss-hours')
    };
    var vipDelayMs = (parseInt(vipConfig.delay, 10) || 2) * 1000;

    var welcomeConfig = {
      enabled: root.getAttribute('data-welcome-enabled'),
      delay: root.getAttribute('data-welcome-delay'),
      dismissHours: root.getAttribute('data-welcome-dismiss-hours')
    };

    var welcomeWillShow = initWelcome(root, welcomeConfig, function () {
      scheduleVip(root, vipConfig, vipDelayMs);
    });

    if (!welcomeWillShow) {
      scheduleVip(root, vipConfig, vipDelayMs);
    }

    initReviews(root, {
      enabled: root.getAttribute('data-reviews-enabled'),
      delay: root.getAttribute('data-reviews-delay'),
      interval: root.getAttribute('data-reviews-interval')
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('.lsp-popup-overlay.is-open').forEach(function (overlay) {
        var closeBtn = overlay.querySelector('[data-lsp-popup-close]');
        if (closeBtn) closeBtn.click();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-popups]').forEach(initPopups);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lsp-popups]');
    if (root) initPopups(root);
  });
})();
